import React, { createContext, useState } from 'react';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

export function isTokenValid(token) {
  if (!token) return false;
  try {
    const { exp } = jwtDecode(token);
    if (exp == null) return true; // permanent token (no expiry claim)
    return Date.now() < exp * 1000;
  } catch {
    return false;
  }
}

// The current user's id, decoded from the token (null if absent/invalid).
function userIdFromToken(token) {
  if (!token) return null;
  try {
    return jwtDecode(token).id ?? null;
  } catch {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => {
    const savedToken = localStorage.getItem('token');
    return isTokenValid(savedToken) ? savedToken : null;
  });

  const [role, setRole] = useState(() => localStorage.getItem('role'));
  const [userId, setUserId] = useState(() => {
    const savedToken = localStorage.getItem('token');
    return isTokenValid(savedToken) ? userIdFromToken(savedToken) : null;
  });

  const login = ({ token, role }) => {
    localStorage.setItem('token', token);
    localStorage.setItem('role', role);
    setToken(token);
    setRole(role);
    setUserId(userIdFromToken(token));
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('username');
    setToken(null);
    setRole(null);
    setUserId(null);
  };

  const isAuthenticated = !!token && isTokenValid(token);

  return (
    <AuthContext.Provider value={{ token, role, userId, login, logout, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthContext;